<template>
  <div class="bb-expense-categories-timeoff-limits">
    <div class="bb-expense-categories-timeoff-limits__title">
      Timeoff Limits
    </div>
    <div class="bb-expense-categories-timeoff-limits-content">
      <div
        v-for="(item, index) in timeOffLimitsList"
        :key="item.id"
        class="bb-expense-categories-timeoff-limits-content-item"
      >
        <div class="bb-expense-categories-timeoff-limits-content-item__name">
          {{item.title}}
        </div>
        <span
          v-if="!isStatusLimit"
          class="bb-expense-categories-timeoff-limits-content-item__input"
        >
          {{item.value}}
        </span>
        <input
          v-else
          class="bb-expense-categories-timeoff-limits-content-item__input"
          v-model="item.value"
          v-autofocus="index === 0"
        >
      </div>
      <button
        class="bb-button bb-expense-categories-timeoff-limits-content__button"
        @click="onButtonClick"
      >
        {{ buttonName }}
      </button>
    </div>
  </div>
</template>

<script>

import TimeoffApi from '@/api/TimeOffLimits/api'

export default {
  name: 'ExpenseCategoriesTimeoffLimits',
  data: () => ({
    timeOffLimitsList: [
      {
        id: 1,
        title: 'Annual leave',
        value: 0
      },
      {
        id: 2,
        title: 'Sick',
        value: 0
      },
      {
        id: 3,
        title: 'Personal leave',
        value: 0
      },
      {
        id: 4,
        title: 'Public holidays',
        value: 0
      },
      {
        id: 5,
        title: 'Remote work',
        value: 0
      }
    ],
    annualLeaveId: 1,
    sickId: 2,
    personalLeaveId: 3,
    publicHolidaysId: 4,
    remoteWorkId: 5,
    timeoofLimitId: null,
    isStatusLimit: false
  }),
  computed: {
    buttonName () {
      return this.isStatusLimit ? 'SAVE' : 'EDIT'
    },
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    onButtonClick () {
      this.isStatusLimit = !this.isStatusLimit
      if (!this.isStatusLimit) this.newTimeoffLimits()
    },
    updateValue ({ annualLeave, sick, personalLeave, publicHoliday, remoteWork, _id }) {
      this.timeoofLimitId = _id
      this.timeOffLimitsList.forEach((el) => {
        switch (el.id) {
        case this.annualLeaveId:
          el.value = annualLeave
          break
        case this.sickId:
          el.value = sick
          break
        case this.personalLeaveId:
          el.value = personalLeave
          break
        case this.publicHolidaysId:
          el.value = publicHoliday
          break
        case this.remoteWorkId:
          el.value = remoteWork
          break
        default:
          return true
        }
      })
    },
    createBody () {
      const body = {
        eventSettingCategory: 2,
        annualLeave: '',
        sick: '',
        personalLeave: '',
        publicHoliday: '',
        remoteWork: '',
        user: this.userInfo.id
      }

      this.timeOffLimitsList.forEach((el) => {
        switch (el.id) {
        case this.annualLeaveId:
          body.annualLeave = el.value
          break
        case this.sickId:
          body.sick = el.value
          break
        case this.personalLeaveId:
          body.personalLeave = el.value
          break
        case this.publicHolidaysId:
          body.publicHoliday = el.value
          break
        case this.remoteWorkId:
          body.remoteWork = el.value
          break
        default:
          return true
        }
      })

      return body
    },
    async newTimeoffLimits () {
      const body = this.createBody()
      const name = this.timeoofLimitId ? 'updateTimeoffLimits' : 'createTimeoffLimits'
      try {
        const { data } = await TimeoffApi[name](body, this.timeoofLimitId)
        this.updateValue(data)
        this.isStatusLimit = false
      } catch (err) {
        console.error(err)
        this.isStatusLimit = false
      }
    },
    async getTimeoffLimits () {
      try {
        const {data} = await TimeoffApi.getTimeoffLimits({})
        const [settings] = data
        if (!settings) return
        this.updateValue(settings)
      } catch (err) {
        console.error(err)
      }
    }
  },
  beforeMount () {
    this.getTimeoffLimits()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

  .bb-expense-categories-timeoff-limits {
    margin: 50px 0 0 0;

    &__title {
      margin: 0 0 13px 0;
      font-weight: 600;
      font-size: 25px;
      line-height: 30px;
      color: $color-denim;
    }
  }

  .bb-expense-categories-timeoff-limits-content {
    display: flex;
    grid-gap: 0 40px;

    &__button {
      width: 85px;
      height: 42px;
      margin: 0 0 0 10px;
    }
  }

  .bb-expense-categories-timeoff-limits-content-item {
    display: flex;
    align-items: center;

    &__name {
      margin: 0 25px 0 0;
      font-size: 14px;
      line-height: 17px;
    }

    &__input {
      font-family: $global-font;
      display: flex;
      align-items: center;
      min-width: 57px;
      max-width: 57px;
      height: 39px;
      border-radius: 6px;
      border: 1px solid $color-mercury;
      padding: 0 14px 0 14px;
      font-size: 14px;
      line-height: 17px;
      font-weight: 500;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/ExpenseCategories/ExpenseCategoriesTimeoffLimits.vue